const convertToCSV = (data, headers) => {
    const headerRow = headers.map((header) => header.title);
    const csvContent = headerRow.join(',') + '\n';

    const csvRows = data.map((row) =>
        headers
            .map((header) => {
                const value = row[header.id];
                return typeof value === 'string' && value.includes(',')
                    ? `"${value}"`
                    : value;
            })
            .join(',')
    );

    return csvContent + csvRows.join('\n');
};

const getCurrentTimestamp = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}-${hours}${minutes}${seconds}`;
};
 
export const handleExportCSV = (orderData,userColumnStatus, labels) => {
    const timeStamp = getCurrentTimestamp();
    const appName = process.env.REACT_APP_NAME;
    const isCorporate = appName?.includes("corporate");
    let orderExport =[
        { id: 'dataPlan', title: labels?.AFFNL0055 },
        { id: 'createdTs', title: labels?.AFFNL0056 },
        { id: 'totalOrderAmount', title: isCorporate ? labels?.AFFNL0153 : labels?.AFFNL0154 },
        { id: 'promoCode', title: labels?.AFFNL0155 },
        { id: 'orderId', title: labels?.AFFNL0062 },
        { id: 'externalReference', title: labels?.AFFNL0063 },
    ];
    const customHeaders = userColumnStatus ? [{id:'userDetails',title: "User details"},...orderExport] : orderExport
    const csvData = convertToCSV(orderData, customHeaders);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `affiliate-${appName}-sales-${timeStamp}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}